import { SupportedChainId } from '@orionprotocol/sdk';
import { isSupportedChainId } from '@orionprotocol/utils';

import { RootStateType } from '../store';
import {
  CurrentVeOrnInfo,
  GovernanceEnvironment,
  GovernancePoolsV2,
  VeOrnInfo,
  VotingInfo,
} from '../slices';
import { Vault } from '../../types';
import { UserQuery } from '../../api/graphql/generated/graphql';

export const getVaultList = (state: RootStateType): Vault[] =>
  state.governance.vaultList;
export const getAvailableUnstakeBalance = (state: RootStateType): string =>
  state.governance.availableUnstakeBalance;

export const getGovernancePools = (
  state: RootStateType,
): GovernancePoolsV2 | undefined => state.governance.pools[state.app.chainId];

export const getGovernanceEnvironment = (
  state: RootStateType,
): GovernanceEnvironment | undefined =>
  state.governance.governanceEnvironments[state.app.chainId];

export const getVeOrnInfo = (state: RootStateType): VeOrnInfo =>
  state.governance.veOrnInfo;

export const getLumiaPInfo = (state: RootStateType): UserQuery =>
  state.governance.lumiaPInfo;

export const getCurrentVeOrnInfo = (state: RootStateType): CurrentVeOrnInfo =>
  state.governance.currentVeOrnInfo;

export const getVotingInfo = (state: RootStateType): VotingInfo =>
  state.governance.votingInfo;

export const getGovernanceSupportedChainIds = (
  state: RootStateType,
): SupportedChainId[] | undefined => {
  const { chainsInfo } = state.governance;

  const chainIds = Object.keys(chainsInfo);

  if (!chainIds.length) return undefined;

  return chainIds.reduce<SupportedChainId[] | undefined>((acc, chId) => {
    if (
      acc === undefined ||
      !isSupportedChainId(chId) ||
      (chainsInfo[chId]?.isLoading ?? true)
    ) {
      return undefined;
    }

    if (chainsInfo[chId]?.data?.isChainSupported ?? false) acc.push(chId);

    return acc;
  }, []);
};
